import Api from "./Api";

export default Api;